export default "__VITE_ASSET__0d4b08e8__"